import { BrandConfigs } from '@PetSureAustralia/petsure-brand-partner-configs/distConfigs/brandConfigs';
import { MakeConfig } from '../../helpers/configHelper';

export const CSPConfigs = MakeConfig({
  config: BrandConfigs.pinscom,
  brokerFriendlyName: 'PINSCOM'
});
